import { useEffect } from "react";
import { fetchCurrentUserPlan } from "src/features/auth/store/actions/subscriptions";
import { useDispatch } from "react-redux";
export const useCurrentPlan = (currentPlan) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchCurrentUserPlan(currentPlan));
    }, [dispatch]);
};
